module.exports = __webpack_public_path__ + "img/tuition_layout3.40db9820.png";